export default __webpack_public_path__ + "static/media/resizecom_gradient_1_A.2ad41bd8.jpeg";